import type {CompRef, Pointer} from '@wix/document-services-types'
import type {
    ManifestExtensionAPI,
    InnerElementsExtensionAPI,
    SlotsExtensionAPI,
    MenuExtensionAPI,
    ComponentsExtensionAPI
} from '@wix/document-manager-extensions'
import {populateInnerElementMenuItemContainerSlot, populateRootMenuItemContainerSlot} from '../../menu/menuUtils'
import type {CreateExtArgs} from '@wix/document-manager-core'
import {slotAlreadyExists} from './autoPopulateAdd'
import {stripHashIfExists} from '../../../utils/refArrayUtils'

const resolveMenuData = (createExtArgs: CreateExtArgs, menuRef: unknown): Record<string, any> | null => {
    const {extensionAPI} = createExtArgs
    const {menus} = extensionAPI as MenuExtensionAPI

    if (typeof menuRef === 'string') {
        const menuId = stripHashIfExists(menuRef)
        return menus.getById(menuId) ?? null
    }

    return menuRef && typeof menuRef === 'object' ? (menuRef as Record<string, any>) : null
}

export const handleMenuItemContainerFlowOnAdd = (createExtArgs: CreateExtArgs, componentRef: Pointer): void => {
    const {extensionAPI} = createExtArgs
    const {manifest} = extensionAPI as ManifestExtensionAPI
    const {slots} = extensionAPI as SlotsExtensionAPI

    const menuItemsManifestEntries = manifest.getData(componentRef, true, [{prop: 'menuItems'}])

    if (!menuItemsManifestEntries.length) {
        return
    }

    const existingRootSlots = slots.getPopulatedSlotNames(componentRef as CompRef)

    for (const manifestEntry of menuItemsManifestEntries) {
        const {value: menuRef, path: innerElementPath, prop: propertyName} = manifestEntry

        if (!menuRef) {
            continue
        }

        const menuData = resolveMenuData(createExtArgs, menuRef)
        if (!menuData?.[propertyName] || !Array.isArray(menuData[propertyName])) {
            continue
        }

        for (const menuItem of menuData[propertyName]) {
            const slotGuid: string | undefined = menuItem?.container
            if (!slotGuid) {
                continue
            }

            if (slotAlreadyExists(createExtArgs, componentRef, slotGuid, innerElementPath, existingRootSlots)) {
                continue
            }

            if (innerElementPath?.length) {
                populateInnerElementMenuItemContainerSlot(
                    extensionAPI as InnerElementsExtensionAPI & ComponentsExtensionAPI,
                    componentRef as CompRef,
                    innerElementPath,
                    slotGuid
                )
            } else {
                populateRootMenuItemContainerSlot(createExtArgs, componentRef as CompRef, slotGuid)
            }
        }
    }
}
